export const CHILD = {
  nickname: 'PRODUCTS.CHILD.shortname',
  isHidden: false,
  lifeInsurance: true,
  icon: 'child'
};
